import { Icon } from "@synergy/icons";
import { Col, Flex, Row } from "antd"; // Importações de componentes de layout e UI da biblioteca Ant Design
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components"; // Importação de 'styled-components' para criar componentes de estilo CSS em JS
import Theme from "../../../../styles/Theme/Theme"; // Importação do tema da aplicação para acessar variáveis de estilo
import { LeftIncidentsOverlay } from "./IncidentsOverlay/LeftIncidentsOverlay"; // Importação do componente BuildingsEventWidget para mostrar eventos relacionados a edifícios

//#region  Styled Components
//Where we define the styles, CSS and other aspects for the page components
const OverlayStyles = styled.div`
  height: Calc(100vh - 152px);
  width: 100%;
  pointer-events: none;

  .overlay-widget {
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.15);
    border-radius: ${Theme.radius["lg"]};
    width: 100%;

    &.field {
      padding: ${Theme.spacing.s02} ${Theme.spacing.s03};
    }
  }
`;

const IconDropdown = styled.div`
  box-shadow: ${Theme.shadow.level3};
  border-radius: 30px;
  width: fit-content;
  margin-left: 10px;
  display: flex;
  background-color: white;
  padding: 5px 5px;
  margin-top: 10px;
  font-weight: 500;

  :hover {
    cursor: pointer;
  }

  p {
    display: flex;
    margin: 0;
    margin-top: 5px;//Needs this to center, otherwise it will be a little bit down (to display align center it needs change in the icon)
    color: ${Theme.color["blue-4"]};
  }

  .threeDParagraph {
    display: flex;
    margin: 0;
    margin-top: 5px;//Needs to be like his to center, otherwise it will be a little bit down (to display align center it needs change in the icon)
    color: ${Theme.color["blue-4"]};
  }

  .marginLeft {
    margin-left: 10px;
    font-weight: 400;
  }
`;

const LayerParagrah = styled.p`
  color: ${(props) => (props.$selectedLayer ? "black" : "gray")};
  margin: 0;
  font-weight: ${(props) => (props.$selectedLayer ? "bold" : "normal")};
`;
//#endregion

// Componente funcional para sobreposição de widgets
export const WidgetsOverlay = ({
  copyMapPois,
  selectedPOI,
  selectedLayer,
  changeLayer,
  selectedFloor,
  openClusterDrawer,
  setIsOnCreateIncidentMode
}) => {

  return (
    // Estilos personalizados para o componente de sobreposição
    <OverlayStyles>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <Flex vertical gap="middle">
            <Row gutter={[Theme.spacing["s03"], Theme.spacing["s03"]]}>
              {selectedLayer === "Incidents" ? (
                <LeftIncidentsOverlay mapPois={copyMapPois} selectedPOI={selectedPOI} selectedFloor={selectedFloor} />
              ) : null}
            </Row>
          </Flex>
        </Col>

        {/* Coluna direita para dropdown de camadas */}
        <Col span={7} offset={11}>
          <Row gutter={[Theme.spacing["s03"], Theme.spacing["s03"]]}>
            <Col span={24} style={{ pointerEvents: "auto", display: "flex", justifyContent: "flex-end" }}>
              <MapDropdowns
                selectedLayer={selectedLayer}
                changeLayer={changeLayer}
                openClusterDrawer={openClusterDrawer}
                setIsOnCreateIncidentMode={setIsOnCreateIncidentMode}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </OverlayStyles>
  );
};

// Componente funcional para dropdown de camadas
const MapDropdowns = ({ selectedLayer, changeLayer, openClusterDrawer, setIsOnCreateIncidentMode }) => {
  const { t } = useTranslation();

  const options = [{ value: "Incidents", label: "incidents_layer" }, { value: "Log Items", label: "log_items_layer" }];

  const items = options.map((item, index) => (
    <li onClick={() => { changeLayer(item.value) }} key={index}
      style={{ fontWeight: item.value === selectedLayer ? '500' : null }}>
      {t('button.' + item.label)}
    </li>
  ));


  //the dropdown is triggered by the 'IconDropdown' component and is rendered using the dropdown from Ant Design
  return (
    <>
      {/* <IconDropdown onClick={(e) => { e.preventDefault(); setIsOnCreateIncidentMode() }}>
        <p className="marginLeft">{t('button.create_incident')}</p>
        <Icon
          iconsize={"md"}
          icon={"Plus"}
          color={"blue-4"}
          bgColor={"white"}
          strokeWidth="2"
        />
      </IconDropdown> */}

      {/* Disable for qa deploy */}
      {/* <div style={{ marginTop: '10px', marginLeft: '10px' }}>
        <Dropdown
          title={t('button.' + options?.find(x => x.value === selectedLayer)?.label)}
          preIcon="Layers"
          postIcon='true'
          boxshadow='true'
        >
          {items}
        </Dropdown>
      </div> */}

      <IconDropdown onClick={openClusterDrawer}>
        <Icon
          iconsize={"md"}
          icon={"DashboardCustomize"}
          color={"blue-4"}
          bgColor={"white"}
        />
      </IconDropdown>
    </>
  );
};